import React, { useState } from "react";
import PropTypes from "prop-types";

const filenameFromContentDisposition = (header) => {
  if (!header) return null;

  const match = header.match(/filename\*?=(?:UTF-8''|")?([^";]+)/i);
  return match ? decodeURIComponent(match[1].replace(/"/g, "")) : null;
};

const EXPORT_FORMATS = {
  pdf: {
    accept: "application/pdf",
    fallbackFilename: "convertflow-funnel-insights.pdf",
    title: "Download insights report as PDF",
  },
  csv: {
    accept: "text/csv",
    fallbackFilename: "convertflow-website-insights.csv",
    title: "Download website performance report as CSV",
  },
};

const ExportTriggerButton = ({
  exportUrl,
  exportFormat = "pdf",
  disabled = false,
  title,
  style = {},
}) => {
  const [status, setStatus] = useState("idle");
  const formatConfig = EXPORT_FORMATS[exportFormat] || EXPORT_FORMATS.pdf;
  const buttonTitle = title || formatConfig.title;

  const handleClick = async () => {
    if (disabled || status === "preparing") return;

    setStatus("preparing");
    try {
      const response = await fetch(exportUrl, {
        headers: { Accept: formatConfig.accept },
      });
      if (!response.ok) {
        throw new Error(`Export request failed with status ${response.status}`);
      }

      const blob = await response.blob();
      const filename =
        filenameFromContentDisposition(response.headers.get("Content-Disposition")) ||
        formatConfig.fallbackFilename;
      const objectUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = objectUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(objectUrl);

      setStatus("idle");
    } catch (error) {
      setStatus("error");
    }
  };

  const label =
    status === "preparing"
      ? "Preparing…"
      : status === "error"
      ? "Export failed"
      : "Export";

  return (
    <button
      type="button"
      className="btn toolbar-btn field-title !border-slate-200"
      style={{ background: "#fff", whiteSpace: "nowrap", ...style }}
      onClick={handleClick}
      disabled={disabled || status === "preparing"}
      title={buttonTitle}
    >
      <span
        className="glyphicon glyphicon-save"
        style={{ fontSize: "12px", marginRight: "5px" }}
      ></span>
      {label}
    </button>
  );
};

ExportTriggerButton.propTypes = {
  exportUrl: PropTypes.string.isRequired,
  exportFormat: PropTypes.oneOf(["pdf", "csv"]),
  disabled: PropTypes.bool,
  title: PropTypes.string,
  style: PropTypes.object,
};

export default ExportTriggerButton;
